module.exports = __webpack_public_path__ + "static/img/bg-fr.52b744a0.png";